import { Form } from "taltech-styleguide";
import { InputSelect } from "@components-common/forms";
export const SpaceFunctionSelect = ({ id, rowNo, options }: any) => {
  return (
    <Form.Group>
      <InputSelect
        //changeFn={() => console.log("Changed")}
        // disabled={
        //   buildingConfigurationFormStore.isReadOnly ||
        //   config.disabled
        // }
        options={options}
        id={id}
        showLabel={false}
      />
    </Form.Group>
  );
};
